module.exports = __webpack_public_path__ + "static/img/circle_bot_icon.77444d73.png";